import React from 'react'

const ManageUserBlackIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7028_7466"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7028_7466)">
        <path
          d="M0.833008 16.6693V14.3359C0.833008 13.8637 0.954536 13.4297 1.19759 13.0339C1.44065 12.638 1.76356 12.3359 2.16634 12.1276C3.02745 11.697 3.90245 11.3741 4.79134 11.1589C5.68023 10.9436 6.58301 10.8359 7.49967 10.8359C8.41634 10.8359 9.31912 10.9436 10.208 11.1589C11.0969 11.3741 11.9719 11.697 12.833 12.1276C13.2358 12.3359 13.5587 12.638 13.8018 13.0339C14.0448 13.4297 14.1663 13.8637 14.1663 14.3359V16.6693H0.833008ZM15.833 16.6693V14.1693C15.833 13.5582 15.6629 12.9714 15.3226 12.4089C14.9823 11.8464 14.4997 11.3637 13.8747 10.9609C14.583 11.0443 15.2497 11.1866 15.8747 11.388C16.4997 11.5894 17.083 11.8359 17.6247 12.1276C18.1247 12.4054 18.5066 12.7144 18.7705 13.0547C19.0344 13.395 19.1663 13.7665 19.1663 14.1693V16.6693H15.833ZM7.49967 10.0026C6.58301 10.0026 5.79829 9.67622 5.14551 9.02344C4.49273 8.37066 4.16634 7.58594 4.16634 6.66927C4.16634 5.7526 4.49273 4.96788 5.14551 4.3151C5.79829 3.66233 6.58301 3.33594 7.49967 3.33594C8.41634 3.33594 9.20106 3.66233 9.85384 4.3151C10.5066 4.96788 10.833 5.7526 10.833 6.66927C10.833 7.58594 10.5066 8.37066 9.85384 9.02344C9.20106 9.67622 8.41634 10.0026 7.49967 10.0026ZM15.833 6.66927C15.833 7.58594 15.5066 8.37066 14.8538 9.02344C14.2011 9.67622 13.4163 10.0026 12.4997 10.0026C12.3469 10.0026 12.1525 9.98524 11.9163 9.95052C11.6802 9.9158 11.4858 9.8776 11.333 9.83594C11.708 9.39149 11.9962 8.89844 12.1976 8.35677C12.399 7.8151 12.4997 7.2526 12.4997 6.66927C12.4997 6.08594 12.399 5.52344 12.1976 4.98177C11.9962 4.4401 11.708 3.94705 11.333 3.5026C11.5275 3.43316 11.7219 3.38802 11.9163 3.36719C12.1108 3.34635 12.3052 3.33594 12.4997 3.33594C13.4163 3.33594 14.2011 3.66233 14.8538 4.3151C15.5066 4.96788 15.833 5.7526 15.833 6.66927Z"
          fill="#454242"
        />
      </g>
    </svg>
  );
}

export default ManageUserBlackIcon